import { render, staticRenderFns } from "./MenuCanvas.vue?vue&type=template&id=3a1027b4&"
import script from "./MenuCanvas.vue?vue&type=script&lang=js&"
export * from "./MenuCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports